import QueryClientProvider from './api/QueryClientProvider';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ToastProvider } from 'react-toast-notifications';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CustomToast, ErrorBoundary, OfflineCover, theme } from '@shared';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes, SessionProvider } from 'App';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <QueryClientProvider>
          <ToastProvider components={{ Toast: CustomToast }}>
            <SessionProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ErrorBoundary>
                  <AppRoutes />
                  <OfflineCover />
                </ErrorBoundary>
              </LocalizationProvider>
            </SessionProvider>
          </ToastProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
